import React, { useEffect, useRef, useCallback, useMemo } from "react";
import "./ProfileCard.css";
import defaultAvatar from "../../assets/avatar.png"; // if in src/assets


const ProfileCardComponent = ({
avatarUrl = defaultAvatar,


  className = "",
  enableTilt = true,
  handle = "ZannyM",
  status = "Online",
  showUserInfo = true,
}) => {
  const wrapRef = useRef(null);
  const cardRef = useRef(null);

  const animationHandlers = useMemo(() => {
    if (!enableTilt) return null;

    const updateCardTransform = (offsetX, offsetY, card, wrap) => {
      const width = card.clientWidth;
      const height = card.clientHeight;
      const percentX = Math.min(Math.max((100 / width) * offsetX, 0), 100);
      const percentY = Math.min(Math.max((100 / height) * offsetY, 0), 100);
      const centerX = percentX - 50;
      const centerY = percentY - 50;

      wrap.style.setProperty("--pointer-x", `${percentX}%`);
      wrap.style.setProperty("--pointer-y", `${percentY}%`);
      wrap.style.setProperty("--rotate-x", `${-(centerX / 5)}deg`);
      wrap.style.setProperty("--rotate-y", `${centerY / 4}deg`);
    };

    return { updateCardTransform };
  }, [enableTilt]);

  const handlePointerMove = useCallback((event) => {
    const card = cardRef.current;
    const wrap = wrapRef.current;
    if (!card || !wrap || !animationHandlers) return;

    const rect = card.getBoundingClientRect();
    animationHandlers.updateCardTransform(
      event.clientX - rect.left,
      event.clientY - rect.top,
      card,
      wrap
    );
  }, [animationHandlers]);

  const handlePointerEnter = useCallback(() => {
    const card = cardRef.current;
    const wrap = wrapRef.current;
    if (!card || !wrap) return;
    
    wrap.classList.add("active");
    card.classList.add("active");
  }, []);

  const handlePointerLeave = useCallback(() => {
    const card = cardRef.current;
    const wrap = wrapRef.current;
    if (!card || !wrap) return;

    wrap.classList.remove("active");
    card.classList.remove("active");
    wrap.style.setProperty("--rotate-x", "0deg");
    wrap.style.setProperty("--rotate-y", "0deg");
  }, []);

  useEffect(() => {
    if (!enableTilt || !animationHandlers) return;

    const card = cardRef.current;
    if (!card) return;

    card.addEventListener("pointerenter", handlePointerEnter);
    card.addEventListener("pointermove", handlePointerMove);
    card.addEventListener("pointerleave", handlePointerLeave);

    return () => {
      card.removeEventListener("pointerenter", handlePointerEnter);
      card.removeEventListener("pointermove", handlePointerMove);
      card.removeEventListener("pointerleave", handlePointerLeave);
    };
  }, [enableTilt, animationHandlers, handlePointerMove, handlePointerEnter, handlePointerLeave]);

  return (
    <div ref={wrapRef} className={`pc-card-wrapper ${className}`.trim()}>
      <section ref={cardRef} className="pc-card">
        <div className="pc-inside">
          <div className="pc-profile-image">
            <img
              src={avatarUrl}
              alt="Profile"
              loading="lazy"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
          
          {showUserInfo && (
            <div className="pc-user-info">
              <div className="pc-user-text">
                <div className="pc-handle">@{handle}</div>
                <div className="pc-status">{status}</div>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default React.memo(ProfileCardComponent);